export default [
  {
    path: '/',
    component: () => import('@/layout/default'),
    children: [
      {
        path: '/',
        name: 'dashboard',
        components: {
          default: () => import('@/views/dashboard/index')
        },
        meta: {
          authRequired: true
        }
      },
      {
        path: '/dashboard',
        name: 'dashboard.index',
        components: {
          default: () => import('@/views/dashboard/index')
        },
        meta: {
          authRequired: true
        }
      }
    ]
  },
  {
    path: '/auth',
    component: () => import('@/layout/auth'),
    children: [
      {
        path: '/',
        name: 'auth.login',
        component: () => import('@/views/auth/login'),
        meta: {
          guestOnly: true
        }
      },
      {
        path: '/logout',
        name: 'auth.logout',
        component: () => import('@/views/auth/logout'),
        meta: {
          guestOnly: true
        }
      }
    ]
  }
]
